// The Chrome Web Store listing for VetraHub Apply.
//
// Lives here because THREE screens now offer the install, and a stale copy in one of them is the
// kind of thing nobody notices until a candidate reports a dead link:
//   - AutopilotSetup  the finish screen, offered to everyone completing onboarding
//   - ApplyTracker    a banner when browser-lane applications are stuck waiting for it
//   - ApplyStatus     in place of the "open in another tab" card, which is false without it
//
// Published 2026-10-17 (item ignomadjaidlkbfopoiodhdmjlmejamf). Setting this to "" is the correct
// way to pull every install prompt at once if the listing is ever taken down: each caller already
// branches on it being falsy and falls back to a disabled state rather than a link to nowhere.
export const CHROME_STORE_URL =
  "https://chromewebstore.google.com/detail/vetrahub-apply/ignomadjaidlkbfopoiodhdmjlmejamf";
